module.exports = __webpack_public_path__ + "static/media/horizontal-rule.df5ed129.svg";